//receive
// POST:/graphdata/project/<int:pro_id>
// POST:/graphdata/document

//Documents [{},{}, ...]
//Ranks [[doc_key...], [], ...]
//References [[a,b], [], ...]
//Translations [[a,b], [], ...]
//Collections [[a,b], [], ...]
//Revisions [[a,b], [], ...]


import { make_graph_N } from "./tree_node.js"
import { make_graph_V } from "./tree_vertex.js"
import { xy_graph_V } from "./tree_xy.js"


export async function drawing(Documents, Ranks, References, Translations, Collections, Revisions) {
    let InputData = {
            documents: Documents,
            ranks: Ranks,
            relations: [
                { rtype: "R", rtable: References },
                { rtype: "C", rtable: Collections },
                { rtype: "T", rtable: Translations },
                { rtype: "V", rtable: Revisions }
            ]
        }
        // console.log("[ACTIONS]tree_drawing/drawing 1 : input_data, ", InputData)

    let GraphN = await make_graph_N(InputData)
        // console.log("[ACTIONS]tree_drawing/drawing 2 : GraphN ", GraphN)

    let GraphV = await make_graph_V(GraphN)
        // console.log("[ACTIONS]tree_drawing/drawing 3 : GraphV ", GraphV)

    GraphV = await xy_graph_V(GraphV)
        // console.log("[ACTIONS]tree_drawing/drawing 4 : position_GV ", GraphV)


    return GraphV
}


// WEBPACK FOOTER //
// ./src/custom/tree_drawing.js